import { create } from 'zustand'

export type ProfileMode = 'entity' | 'business_client'

interface ProfileStore {
  activeMode: ProfileMode
  setActiveMode: (mode: ProfileMode) => void
  reset: () => void
}

const STORAGE_KEY = 'active_profile_mode'

function getInitialMode(): ProfileMode {
  if (typeof window === 'undefined') return 'entity'
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored === 'business_client') return 'business_client'
  } catch {
    // ignore
  }
  return 'entity'
}

export const useProfileStore = create<ProfileStore>((set) => ({
  activeMode: getInitialMode(),

  setActiveMode: (mode) => {
    try {
      localStorage.setItem(STORAGE_KEY, mode)
    } catch {
      // ignore
    }
    set({ activeMode: mode })
  },

  reset: () => {
    try {
      localStorage.removeItem(STORAGE_KEY)
    } catch {
      // ignore
    }
    set({ activeMode: 'entity' })
  },
}))

if (typeof window !== 'undefined') {
  window.addEventListener('auth:logout', () => {
    useProfileStore.getState().reset()
  })
}
